import React from "react";
import { Bell } from "lucide-react";
import { newIn } from "../../mock/mock";

const NewInHeading = () => (
  <div className="flex items-end justify-between mb-12">
    <div>
      <p className="font-body text-xs font-semibold tracking-wide-sm uppercase text-[#C8102E] mb-3">
        Just Dropped
      </p>
      <h2 className="font-display text-4xl md:text-6xl text-[#1A1A1A]">
        New In
      </h2>
    </div>
    <span className="hidden md:inline-block font-body text-sm font-semibold text-[#999] cursor-not-allowed">
      Coming Soon
    </span>
  </div>
);

const NewInCard = ({ product }) => (
  <div className="group">
    <div className="relative aspect-[3/4] overflow-hidden rounded-xl bg-white mb-4">
      <img
        src={product.image}
        alt={product.name}
        className="w-full h-full object-cover img-hover opacity-95"
      />
      <div className="absolute inset-0 bg-[#1A1A1A]/35 flex items-center justify-center">
        <span className="font-display text-white text-lg md:text-2xl tracking-wide-sm text-center px-3">
          Coming Soon
        </span>
      </div>
      <span className="absolute top-3 left-3 bg-white/95 text-[#1A1A1A] text-[10px] font-semibold uppercase tracking-wide-sm px-2.5 py-1 rounded-full">
        {product.badge}
      </span>
    </div>
    <div className="flex items-start justify-between gap-2">
      <h3 className="font-body text-sm md:text-[15px] font-medium text-[#1A1A1A] leading-snug">
        {product.name}
      </h3>
      <span className="inline-flex items-center gap-1 font-body text-xs font-semibold text-[#C8102E] whitespace-nowrap">
        <Bell size={13} strokeWidth={2} /> Soon
      </span>
    </div>
  </div>
);

const NewInSection = () => {
  return (
    <section id="new-in" className="bg-[#FBF5F6] py-20 md:py-28">
      <div className="max-w-[1400px] mx-auto px-5 md:px-8">
        <NewInHeading />
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {newIn.map((p) => (
            <NewInCard key={p.id} product={p} />
          ))}
        </div>
        <p className="text-center font-body text-sm text-[#888] mt-12">
          Our first collection is on the way. No items in stock just yet.
          Join the list below to shop the drop first.
        </p>
      </div>
    </section>
  );
};

export default NewInSection;
